import {
  APIResponseType,
  createDeleteApiHook,
  createGetApiHook,
  createPatchApiHook,
  createPostApiHook,
} from "@/shared";

// exp reaction
const getExpReactionListAPI = ({ pageId }: { pageId: number }) =>
  `/main-card/pages/${pageId}/reaction`;

export const useGetExpReactionList = createGetApiHook<APIResponseType<any>, { pageId: number }>(
  getExpReactionListAPI
);

const addExpReactionAPI = ({ pageId }: { pageId: number }) => `/main-card/pages/${pageId}/reaction`;
export const useAddExpReaction = createPostApiHook<{}, { pageId: number }, APIResponseType<any>>(
  addExpReactionAPI,
  {
    isFormDataMethod: false,
  }
);

const getExpCommentListAPI = ({ pageId }: { pageId: number }) =>
  `/main-card/pages/${pageId}/comment`;
export const useGetExpCommentList = createGetApiHook<
  APIResponseType<any>,
  { pageId: number; headers?: Record<string, string> }
>(getExpCommentListAPI);

const addExpCommentAPI = ({ pageId }: { pageId: number }) => `/main-card/pages/${pageId}/comment`;
export const useAddExpComment = createPostApiHook<
  {},
  { pageId: number; headers?: Record<string, string> },
  APIResponseType<any>
>(addExpCommentAPI, {
  isFormDataMethod: false,
});

const editExpCommentAPI = ({ commentId }: { commentId: number }) =>
  `/main-card/pages/comment/${commentId}`;

export const useEditExpComment = createPatchApiHook<
  {},
  { commentId: number },
  APIResponseType<any>
>(editExpCommentAPI, {
  isFormDataMethod: false,
});

const deleteExpCommentAPI = ({ commentId }: { commentId: number }) =>
  `/main-card/pages/comment/${commentId}`;
export const useDeleteExpComment = createDeleteApiHook<
  {},
  { commentId: number; headers?: Record<string, string> },
  APIResponseType<any>
>(deleteExpCommentAPI, {
  isFormDataMethod: false,
});

const getTipListAPI = ({ pageId }: { pageId: number }) => `/main-card/pages/${pageId}/tip`;
export const useGetTipList = createGetApiHook<APIResponseType<any>, { pageId: number }>(
  getTipListAPI
);

const addTipAPI = ({ pageId }: { pageId: number }) => `/main-card/pages/${pageId}/tip`;
export const useAddTip = createPostApiHook<{}, { pageId: number }, APIResponseType<any>>(
  addTipAPI,
  {
    isFormDataMethod: false,
  }
);
